export default __webpack_public_path__ + "static/identity-dark-299383236d5d74cdac51083237f87499.png";